import React from "react";
import { toast } from "@catchoftheday/cg-components";
import { HEADER_TOAST_CONTAINER_ID } from "@header-app/components/HeaderToast";
import { ToastContent } from "@header-app/components/HeaderToast/ToastContent";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var createToast = function createToast(_ref) {
  var toastContent = _ref.toastContent,
      toastId = _ref.toastId;
  return toast(___EmotionJSX(ToastContent, toastContent), {
    containerId: HEADER_TOAST_CONTAINER_ID,
    position: "top-center",
    autoClose: 5000,
    toastId: toastId
  });
};
export var updateToast = function updateToast(_ref2) {
  var toastContent = _ref2.toastContent,
      toastId = _ref2.toastId;
  toast.update(toastId, {
    containerId: HEADER_TOAST_CONTAINER_ID,
    render: ___EmotionJSX(ToastContent, toastContent)
  });
};